<template>
  <div>
    <v-layout class="pull-left">
      <v-dialog :modelValue="show" max-width="450px" @keydown.esc="$emit('close')" @click:outside="$emit('close')">
        <v-card>
          <v-form @submit.prevent ref="form" v-model="valid" v-on:submit.prevent="print">

            <v-card-title style="margin-bottom: px !important">
              <span class="headline">{{ title }}</span>
            </v-card-title>

            <v-card-text class="mt-4">
              <v-combobox 
                v-model="item.measure" 
                name="measure" 
                item-title="name" 
                item-value="id"
                :items="measures" 
                label="Medidas de papel*" 
                autocomplete="off"
                :rules="[rules.requiredComboBox]"
              ></v-combobox>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="$emit('close')">Cancelar</v-btn>
              <v-btn color="success" text type="submit" :loading="loading">Imprimir</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";
import { asnService } from "@/libs/ws/asnService";

export default {
  props: {
    show: Boolean,
    close: Function,
    asn: Object,
    lpn: Object,
    selectedLpns: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'asn', // 'asn' o 'lpn'
      validator: (value) => ['asn', 'lpn'].includes(value)
    }
  },
  name: "ModalPrintWitness",
  mixins: [ValidMixin],
  created() { },
  data() {
    return {
      loading: false,
      item: {
        measure: { id: 1, name: "A4" },
      },
      defaultItem: {
        measure: { id: 1, name: "A4" },
      },
      measures: [
        { id: 1, name: "A4" },
        { id: 2, name: "10x15" },
        { id: 3, name: "10x8" }
      ]
    };
  },
 
  watch: {
    show() {
      this.item = JSON.parse(JSON.stringify(this.defaultItem));
    }
  },
  mounted() {
  },
  computed: {
    title() {
      if (this.type === 'lpn') {
        return 'Imprimir etiqueta testigo de LPN';
      }
      if (this.selectedLpns && this.selectedLpns.length > 0) {
        return `Imprimir etiquetas testigo de ${this.selectedLpns.length} LPN${this.selectedLpns.length > 1 ? 's' : ''}`;
      }
      return 'Imprimir etiquetas testigo de recepción';
    },
    entityId() {
      return this.type === 'lpn' ? this.lpn?.id : this.asn?.id;
    },
    entityName() {
      return this.type === 'lpn' ? this.lpn?.code : `ASN-${this.asn?.id}`;
    }
  },
  methods: {
    print() {
      if (this.loading) return;

      if (this.valid) {
        const measureValue = this.item.measure != null ? this.item.measure.name : null;

        if (!measureValue) {
          this.toast.error("Debe seleccionar una medida de papel");
          return;
        }

        const params = {
          measure: measureValue
        };

        // Si es tipo LPN, agregar lpn_id a los parámetros
        if (this.type === 'lpn' && this.lpn) {
          params.lpn_id = this.lpn.id;
        }

        // Si hay LPNs seleccionados (múltiples), agregar lpn_ids
        if (this.selectedLpns && this.selectedLpns.length > 0) {
          params.lpn_ids = this.selectedLpns.map(lpn => lpn.id);
        }

        this.loading = true;

        // Siempre usar printWitness pero con el ASN id
        const asnId = this.type === 'lpn' && this.lpn?.asn_id 
          ? this.lpn.asn_id 
          : this.asn?.id;

        if (!asnId) {
          this.toast.error("No se pudo obtener el ID del ASN");
          this.loading = false;
          return;
        }

        asnService.printWitness(asnId, params)
          .then((response) => {
            try {
              // Transformo a string la respuesta para poder enviar mensajes de error
              let result = JSON.parse(this.arrayBufferToString(response.data));
              if (!result.status) {
                this.toast.error(result.msg);
              }
            } catch (e) {
              // Es un PDF válido, descargar el archivo
              const blob = new Blob([response.data], {
                type: "application/pdf",
              });
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              
              // Nombre del archivo según el contexto
              let fileName;
              if (this.type === 'lpn') {
                fileName = `Testigo-Recepcion-LPN-${this.lpn.code}.pdf`;
              } else if (this.selectedLpns && this.selectedLpns.length > 0) {
                fileName = `Testigos-Recepcion-ASN-${asnId}-${this.selectedLpns.length}LPNs.pdf`;
              } else {
                fileName = `Testigos-Recepcion-ASN-${asnId}.pdf`;
              }
              
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(link.href);
              
              const successMsg = this.type === 'lpn'
                ? 'Testigo de recepción descargado correctamente'
                : 'Testigos de recepción descargados correctamente';
              this.toast.success(successMsg);
              this.item = JSON.parse(JSON.stringify(this.defaultItem));
              this.$emit("close");
            }
          })
          .catch((error) => {
            console.log("Error en printWitness:", error);
            console.log("Error response:", error.response);
            this.toast.error("Error al imprimir el testigo de recepción");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    arrayBufferToString(buffer) {
      var arr = new Uint8Array(buffer);
      var str = String.fromCharCode.apply(String, arr);
      if (/[\u0080-\uffff]/.test(str)) {
        throw new Error(
          "this string seems to contain (still encoded) multibytes"
        );
      }
      return str;
    },
  },
};
</script>
